import { render, staticRenderFns } from "./mammal.vue?vue&type=template&id=5dbac21b&scoped=true&"
import script from "./mammal.vue?vue&type=script&lang=js&"
export * from "./mammal.vue?vue&type=script&lang=js&"
import style0 from "./mammal.vue?vue&type=style&index=0&id=5dbac21b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbac21b",
  null
  
)

export default component.exports